import './App.css';
import Created from './router/created';
import { useEffect } from 'react';
import { reloadWhenVersionChanges } from './utils/appVersion';

function App() {
  useEffect(() => {
    const checkVersion = () => {
      if (document.visibilityState === 'visible') {
        reloadWhenVersionChanges();
      }
    };

    checkVersion();
    document.addEventListener('visibilitychange', checkVersion);
    window.addEventListener('focus', checkVersion);

    return () => {
      document.removeEventListener('visibilitychange', checkVersion);
      window.removeEventListener('focus', checkVersion);
    };
  }, []);

  return (
    <div className="App">
      <Created/>
    </div>
  );
}

export default App;
